import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function ForNotFor() {
  const forWho = ['Personas que acaban de descubrir una traición y no pueden dejar de temblar.', 'Parejas que llevan meses estancadas en el reproche y la desconfianza.', 'Quienes cometieron el error y quieren saber si existe una forma real de reparar el daño.', 'Hombres y mujeres que sienten que han perdido su identidad tras la infidelidad.'];
  const notForWho = ['Personas que buscan métodos de venganza o hackeo de cuentas.', 'Quienes ya están en un proceso legal de divorcio agresivo.', 'Parejas con violencia física activa (busquen ayuda profesional inmediata).'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#141414]" data-id="element-38">
      <div className="max-w-5xl mx-auto" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-40">
          {/* Para ti si */}
          <FadeIn data-id="element-41">
            <div className="bg-[#1a1a1a] rounded-2xl p-8 border border-brand-amber/20 h-full" data-id="element-42">
              <h3 className="text-2xl font-serif text-brand-offwhite mb-8 flex items-center gap-3" data-id="element-43">
                <div className="w-10 h-10 rounded-full bg-green-900/30 flex items-center justify-center" data-id="element-44">
                  <Check className="w-6 h-6 text-green-500" data-id="element-45" />
                </div>
                Para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-46">
                {forWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-47">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-1 opacity-70" data-id="element-48" />
                    <span className="text-brand-offwhite/80 leading-relaxed" data-id="element-49">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NO es para ti si */}
          <FadeIn delay={0.2} data-id="element-50">
            <div className="bg-[#1a1a1a] rounded-2xl p-8 border border-white/5 h-full" data-id="element-51">
              <h3 className="text-2xl font-serif text-brand-offwhite mb-8 flex items-center gap-3" data-id="element-52">
                <div className="w-10 h-10 rounded-full bg-red-900/30 flex items-center justify-center" data-id="element-53">
                  <X className="w-6 h-6 text-red-500" data-id="element-54" />
                </div>
                NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-55">
                {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-56">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1 opacity-70" data-id="element-57" />
                    <span className="text-brand-offwhite/80 leading-relaxed" data-id="element-58">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}